/**
 * Created by - Ashish Dewangan on 08-07-2024
 * Reason - To have header component
 */
import React, { useContext, useEffect, useState } from "react";
import headerStyle from "./header.module.css";
import config from "../../Api/config";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { GlobalContext } from "../../context/Context";
import TopHeader from "./TopHeader";
import { GiHamburgerMenu } from "react-icons/gi";
import { Drawer } from "antd";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import { MdDownload } from "react-icons/md";
import { MdArrowDropDown } from "react-icons/md";
// import topHeaderStyle from "../Header/topHeader.module.css";
import { FaMobileAlt } from "react-icons/fa";
// import { IoCall } from "react-icons/io5";
import { MdEmail } from "react-icons/md";
import { IoMdCall } from "react-icons/io";
import { IoCall } from "react-icons/io5";
import { IoCallOutline } from "react-icons/io5";
import { HiOutlineMail } from "react-icons/hi";
import { IoHome } from "react-icons/io5";
import { GrHomeRounded } from "react-icons/gr";
import Marquee from "react-fast-marquee";
import { CloseOutlined } from "@ant-design/icons";

const Header = () => {
  const { user, setUser, settingDetail } = useContext(GlobalContext);
  const [activeLink, setActiveLink] = useState("");

  const location = useLocation();
  const [currentPath, setCurrentPath] = useState("");

  const [isOpen, setIsOpen] = React.useState(false);

  const [showSubmenu1, setShowSubmenu1] = useState(false);
  const [showSubmenu2, setShowSubmenu2] = useState(false);
  const [showSubmenu3, setShowSubmenu3] = useState(false);
  const [logoHeight, setLogoHeight] = useState("14vh");
  const [logoWidth, setLogoWidth] = useState("7.5vw");
  // const [headerBackgroundColor, setHeaderBackgroundColor] = useState(
  //   "rgba(255, 112, 108, 1)"
  // );
  const [headerBackgroundColor, setHeaderBackgroundColor] = useState("#F1B830");
  useEffect(() => {
    setCurrentPath(location.pathname);
    setActiveLink(location.pathname);
  }, [location.pathname]);

  const [colorChange, setColorChange] = useState(" ");
  const [topHeaderVisibility, setTopHeaderVisibility] = useState(" ");
  useEffect(() => {
    const changeNavbarColor = () => {
      if (window.scrollY >= 30) {
        setColorChange("var(--header-background-image)");
        setTopHeaderVisibility("none");
        setLogoHeight("6.6vh");
        setLogoWidth("3.3vw");
        // setHeaderBackgroundColor("rgba(229, 236, 232)");
        // setHeaderBackgroundColor("rgba(255, 112, 108, 1)");
        setHeaderBackgroundColor("#F1B830");
      } else {
        setColorChange("var(--transparent-background)");
        setTopHeaderVisibility("flex");
        setLogoHeight("14vh");
        setLogoWidth("7.5vw");
        // setHeaderBackgroundColor("rgba(247, 245, 247, 0.5)");
        // setHeaderBackgroundColor("rgba(255, 112, 108, 1)");
        setHeaderBackgroundColor("#F1B830");
      }
    };
    window.addEventListener("scroll", changeNavbarColor);
    return () => {
      window.removeEventListener("scroll", changeNavbarColor);
    };
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
    getHeaderLogo();
  }, []);

  const getHeaderLogo = async () => {};

  const closeDrawer = () => {
    setIsOpen((prevState) => !prevState);
    setShowSubmenu1(false);
    setShowSubmenu2(false);
    setShowSubmenu3(false);
  };

  return (
    <div className={`${headerStyle.header} `}>
      <div
        className={headerStyle.topHeaderContainer}
        style={
          currentPath == "/"
            ? { display: topHeaderVisibility }
            : { display: topHeaderVisibility }
        }
      >
        <TopHeader />
      </div>
      <div
        className={`${headerStyle.mainHeaderContainer}  `}
        style={{ background: headerBackgroundColor }}
      >
        <div className={`${headerStyle.iconContainer} `}>
          <GiHamburgerMenu
            onClick={closeDrawer}
            className={`${headerStyle.button}`}
          />
        </div>
        <Drawer
          headerStyle={{
            // background: "rgba(247, 245, 247, 1)",
            background: "#F1B830",
            display: "flex",
          }}
          open={isOpen}
          onClose={closeDrawer}
          placement="right"
          className={`${headerStyle.hamburgerDrawer}`}
          title="Nair Samajam"
          width={280}
          closeIcon={
            <CloseOutlined style={{ color: "black", fontSize: "16px" }} />
          }
        >
          <ul
            style={{
              listStyle: "none",
              padding: 0,
              margin: 0,
            }}
            className={`${headerStyle.drawerMenu}}`}
          >
            <li className={headerStyle.li}>
              <Link onClick={closeDrawer} to="/" className={headerStyle.link}>
                Home
              </Link>
            </li>
            <hr className={`${headerStyle.horizontalLine}`} />
            <li className={headerStyle.li}>
              <Link
                onClick={closeDrawer}
                to="/about_us"
                className={`${headerStyle.link} `}
                style={{ textDecoration: "none", color: "black" }}
              >
                About Us
              </Link>
              <hr className={`${headerStyle.horizontalLine}`} />
            </li>
            <li className={headerStyle.li}>
              <Link
                onClick={closeDrawer}
                to="/members"
                className={`${headerStyle.link} `}
                style={{ textDecoration: "none", color: "black" }}
              >
                Members
              </Link>
              <hr className={`${headerStyle.horizontalLine}`} />
            </li>
            {/* End of code - Yogen on 11-06-2025
            Reason - To add members tab */}
            <li className={headerStyle.li}>
              <Link
                onClick={closeDrawer}
                to="/matrimony"
                className={`${headerStyle.link} `}
                style={{ textDecoration: "none", color: "black" }}
              >
                Matrimony
              </Link>
              <hr className={`${headerStyle.horizontalLine}`} />
            </li>
            {/* Added by - Ashlekh on 12-04-2025
            Reason - To add school and matrimony tab */}
            <li className={headerStyle.li}>
              <Link
                onClick={closeDrawer}
                to="/events"
                className={`${headerStyle.link} `}
                style={{ textDecoration: "none", color: "black" }}
              >
                Events
              </Link>
              <hr className={`${headerStyle.horizontalLine}`} />
            </li>
            {/* Added by - Ashlekh on 21-04-2025
            Reason - To add career page */}
            <li className={headerStyle.li}>
              <Link
                onClick={closeDrawer}
                to="/career"
                className={`${headerStyle.link} `}
                style={{ textDecoration: "none", color: "black" }}
              >
                Career
              </Link>
              <hr className={`${headerStyle.horizontalLine}`} />
            </li>
            {/* End of code - Ashlekh on 21-04-2025
            Reason - To add career page */}
            <li className={headerStyle.li}>
              <Link
                onClick={closeDrawer}
                to="/school"
                className={`${headerStyle.link} `}
                style={{ textDecoration: "none", color: "black" }}
              >
                School
              </Link>
              <hr className={`${headerStyle.horizontalLine}`} />
            </li>
            {/* End of code - Ashlekh on 12-04-2025
            Reason - To add school and matrimony tab */}
            <li className={headerStyle.li}>
              <Link
                onClick={closeDrawer}
                to="/news"
                className={`${headerStyle.link} `}
                style={{ textDecoration: "none", color: "black" }}
              >
                News
              </Link>
              <hr className={`${headerStyle.horizontalLine}`} />
            </li>
            <li className={headerStyle.li}>
              <Link
                onClick={closeDrawer}
                to="/contact"
                className={`${headerStyle.link} `}
                style={{ textDecoration: "none", color: "black" }}
              >
                Contact Us
              </Link>
              <hr className={`${headerStyle.horizontalLine}`} />
            </li>
            <li className={headerStyle.li}>
              <Link
                onClick={closeDrawer}
                to="/gallery"
                className={`${headerStyle.link} `}
                style={{ textDecoration: "none", color: "black" }}
              >
                Gallery
              </Link>
              <hr className={`${headerStyle.horizontalLine}`} />
            </li>
            {settingDetail.brochure &&
              settingDetail.brochure?.trim()?.length > 0 && (
                <li className={`${headerStyle.li}`}>
                  <Link
                    onClick={closeDrawer}
                    className={`${headerStyle.link}`}
                    to={`${config.baseURL}${settingDetail?.brochure}`}
                    target="_blank"
                  >
                    Download Brochure
                    <MdDownload
                      className={`${headerStyle.downloadBroucherIconForDrawer}`}
                      style={{ fontSize: "25px" }}
                    />
                  </Link>
                  <hr className={`${headerStyle.horizontalLine}`} />
                </li>
              )}
          </ul>
        </Drawer>
        <div className={`${headerStyle.contactContainer}`}>
          <Marquee>
            {settingDetail?.business_contact_number ? (
              <div className={headerStyle.contacts}>
                <IoMdCall className={headerStyle.callIcon} />
                <b
                  className={headerStyle.titleOfContacts}
                  style={{ fontWeight: "500" }}
                >
                  Contact Number
                </b>
                <span>{settingDetail?.business_contact_number}</span>
              </div>
            ) : null}

            {settingDetail?.email || settingDetail?.second_email ? (
              <div className={headerStyle.contacts}>
                <MdEmail className={headerStyle.emailIcon} />
                <b
                  className={headerStyle.titleOfContacts}
                  style={{ fontWeight: "500" }}
                >
                  Email :
                </b>
                <span> {settingDetail?.email}</span>
                {settingDetail?.email ? <> || </> : null}
                <span> {settingDetail?.second_email}</span>
              </div>
            ) : null}
          </Marquee>
        </div>
        <div className={`${headerStyle.navbar} `}>
          <div
            className={`${headerStyle.navbarItem} ${headerStyle.link} ${headerStyle.navbarFont}`}
          >
            <Link
              to="/"
              className={`${headerStyle.navbarItem} ${headerStyle.link} ${
                headerStyle.navbarFont
              }
              ${activeLink == "/" && headerStyle.active}`}
            >
              <IoHome style={{ height: "20px", width: "20px" }} />
            </Link>
          </div>
          <div
            className={`${headerStyle.navbarItem} ${headerStyle.link} ${headerStyle.navbarFont}`}
          >
            <Link
              to="/about_us"
              className={`${headerStyle.navbarItem} ${headerStyle.link} ${
                headerStyle.navbarFont
              }
              ${activeLink == "/about_us" && headerStyle.active}`}
            >
              About Us
            </Link>
          </div>

          <div
            className={`${headerStyle.navbarItem} ${headerStyle.link} ${headerStyle.navbarFont}`}
            style={{ cursor: "pointer" }}
          >
            <Link
              to="/members"
              className={`${headerStyle.navbarItem} ${headerStyle.link} ${
                headerStyle.navbarFont
              }
              ${activeLink == "/members" && headerStyle.active}`}
            >
              Members
            </Link>
          </div>
          <div
            className={`${headerStyle.navbarItem} ${headerStyle.link} ${headerStyle.navbarFont}`}
          >
            <Link
              to="/matrimony"
              className={`${headerStyle.navbarItem} ${headerStyle.link} ${
                headerStyle.navbarFont
              }
              ${activeLink == "/matrimony" && headerStyle.active}`}
            >
              Matrimony
            </Link>
          </div>
          <div
            className={`${headerStyle.navbarItem} ${headerStyle.link} ${headerStyle.navbarFont}`}
            style={{ cursor: "pointer" }}
          >
            <Link
              to="/events"
              className={`${headerStyle.navbarItem} ${headerStyle.link} ${
                headerStyle.navbarFont
              }
              ${activeLink == "/events" && headerStyle.active}`}
            >
              Events
            </Link>
          </div>
          {settingDetail?.logo?.length > 0 ? (
            <Link to="">
              <img
                src={config.baseURL + settingDetail?.logo}
                alt=""
                className={`${headerStyle.logo}`}
                style={{ height: logoHeight, width: logoWidth }}
              />
            </Link>
          ) : null}

          {/* Added by - Ashlekh on 21-04-2025
          Reason - To add career tab */}
          <div
            className={`${headerStyle.navbarItem} ${headerStyle.link} ${headerStyle.navbarFont}`}
          >
            <Link
              to="/career"
              className={`${headerStyle.navbarItem} ${headerStyle.link} ${
                headerStyle.navbarFont
              }
              ${activeLink == "/career" && headerStyle.active}`}
            >
              Career
            </Link>
          </div>
          <div
            className={`${headerStyle.navbarItem} ${headerStyle.link} ${headerStyle.navbarFont}`}
          >
            <Link
              to="/school"
              className={`${headerStyle.navbarItem} ${headerStyle.link} ${
                headerStyle.navbarFont
              }
              ${activeLink == "/school" && headerStyle.active}`}
            >
              School
            </Link>
          </div>
          <div
            className={`${headerStyle.navbarItem} ${headerStyle.link} ${headerStyle.navbarFont}`}
            style={{ cursor: "pointer" }}
          >
            <Link
              to="/news"
              className={`${headerStyle.navbarItem} ${headerStyle.link} ${
                headerStyle.navbarFont
              }
              ${activeLink == "/news" && headerStyle.active}`}
            >
              News
            </Link>
          </div>
          <div
            className={`${headerStyle.navbarItem} ${headerStyle.link} ${headerStyle.navbarFont}`}
            style={{ cursor: "pointer" }}
          >
            <Link
              to="/contact"
              className={`${headerStyle.navbarItem} ${headerStyle.link} ${
                headerStyle.navbarFont
              } ${activeLink == "/contact" && headerStyle.active}`}
            >
              Contact Us
            </Link>
          </div>
          <div
            className={`${headerStyle.navbarItem} ${headerStyle.link} ${headerStyle.navbarFont}`}
            style={{ cursor: "pointer" }}
          >
            <Link
              to="/gallery"
              className={`${headerStyle.navbarItem} ${headerStyle.link} ${
                headerStyle.navbarFont
              }
              ${activeLink == "/gallery" && headerStyle.active}`}
            >
              Gallery
            </Link>
          </div>
          {/* <div
            className={`${headerStyle.navbarItem} ${headerStyle.link} ${headerStyle.navbarFont}`}
            style={{ cursor: "pointer" }}
          >
            <Link
              to="/contact"
              className={`${headerStyle.navbarItem} ${headerStyle.link} ${
                headerStyle.navbarFont
              } ${activeLink == "/contact" && headerStyle.active}`}
            >
              Contact Us
            </Link>
          </div> */}
          {settingDetail.brochure &&
            settingDetail.brochure?.trim()?.length > 0 && (
              <div className={`${headerStyle.downloadBrochure}`}>
                <Link
                  className={`${headerStyle.downloadBrochureButton}`}
                  to={`${config.baseURL}${settingDetail?.brochure}`}
                  target="_blank"
                >
                  <div className={`${headerStyle.downloadBroucherText}`}>
                    Download Brochure
                  </div>
                  <MdDownload
                    className={`${headerStyle.downloadBroucherIcon}`}
                    style={{ fontSize: "25px" }}
                  />
                </Link>
              </div>
            )}
        </div>
      </div>
    </div>
  );
};

export default Header;
